import { Tabs, Tab } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import React from 'react'
import clsx from 'clsx'
import { $Gray90, $primaryColor } from '@Styles/colors'
import './CustomTabs.scss'

// custom function to get text width
function getTextWidth(text: string, font: string) {
    const canvas = document.createElement('canvas')
    const context: any = canvas.getContext('2d')
    context.font = font || getComputedStyle(document.body).font
    return context.measureText(text).width
}

const useStyles = makeStyles(() => ({
    root: {
        fontSize: 14,
        minHeight: '44px !important',
        // flexGrow: 1,
        // backgroundColor: ,
        '& .MuiButtonBase-root': {
            opacity: 1,
            fontWeight: 600,
            textTransform: 'capitalize',
            fontFamily: 'unset',
        },
        '& .MuiTabs-scroller': {
            background: 'linear-gradient(180deg, #FFFFFF 0%, #F5F5F5 100%)',
            borderRadius: '10px !important',
            minHeight: '44px !important',
            // borderBottom: '1px solid grey',
            position: 'relative',

            '&::after': {
                content: '" "',
                display: 'block',
                position: 'absolute',
                width: '100%',
                height: '1px',
                background: $Gray90,
                top: 47,
            },
        },
        '& .MuiTabs-indicator': {
            backgroundColor: $primaryColor,
            height: 4,
            borderRadius: 10,
            // width: '80px !important',
            // marginLeft: '30px',
        },
        '& .MuiTab-wrapper': {
            textTransform: 'capitalize',
            fontWeight: 'bold',
            // color: '#000000',
        },
        '& .Mui-selected': {
            color: `${$primaryColor} !important`,
        },
    },
}))

function a11yProps(index: any) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    }
}

interface ICustomTabs {
    tabs: string[]
    value: any
    onChange: (event: any, number: number) => void
    className?: string
}

function CustomTabs(props: ICustomTabs) {
    // core section
    const { tabs, value, onChange, className } = props
    const classes = useStyles()

    return (
        <div className={clsx(classes.root, className)}>
            <Tabs
                value={value}
                onChange={onChange}
                aria-label="simple tabs example"
            >
                {tabs.map((tab, index) => (
                    <Tab
                        label={tab}
                        {...a11yProps(index)}
                        key={`${tab}_custon_tabs`}
                    />
                ))}
            </Tabs>
        </div>
    )
}

export default CustomTabs
